module.exports = __webpack_public_path__ + "img/Pellets-asche.d87ba35.webp";